import React, {
  useCallback,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useState,
  forwardRef,
} from "react";

import { BookingResourcesProvider } from "../context/AvailableOrders";
import { BookingProvider } from "../context/Booking";
import { ShipmentResourcesProvider } from "../context/Resources";
import { BookingViewTabs } from "./components/Tabs";

interface Props {}

export interface BookingViewHandles {
  open: (bookingId: number) => void;
  close: () => void;
}

const BookingViewComponent: ForwardRefRenderFunction<BookingViewHandles, Props> = (_, ref) => {
  const [isSidebarOpened, setIsSidebarOpened] = useState<boolean>(false);
  const [keyId, setKeyId] = useState<number>();

  const onOpenSidebar = useCallback(
    (bookingId: number) => {
      // eslint-disable-next-line
      if (keyId != bookingId) setKeyId(bookingId);

      setIsSidebarOpened(true);
    },
    [keyId]
  );

  const onCloseSidebar = useCallback(() => {
    setIsSidebarOpened(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open: onOpenSidebar,
    close: onCloseSidebar,
  }));

  return (
    <BookingProvider>
      <ShipmentResourcesProvider>
        <BookingResourcesProvider>
          <BookingViewTabs
            keyId={keyId}
            isSidebarOpened={isSidebarOpened}
            onCloseSidebar={onCloseSidebar}
          />
        </BookingResourcesProvider>
      </ShipmentResourcesProvider>
    </BookingProvider>
  );
};

export default forwardRef(BookingViewComponent);
